import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import ReactGA from 'react-ga4'

import Header from '../components/bars/header/header'
import Footer from '../components/bars/footer/footer'
import CustomAlert from '../components/alert/custom-alert'
import { storeMobileVersionActionCreator, storeSelectedLanguageActionCreator } from '../redux/actions/actions'
import { BREAKPOINT_MD } from '../utils/constants'
import { LANGUAGES_BY_BRAND } from '../i18n'
import Router from '../components/routing/Router'

const useStyles = makeStyles((theme) => ({
  landing: (props) => ({
    height: props.minHeight,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      minHeight: '100vh'
    }
  })
}))

const Landing = ({ locale }) => {
  const dispatch = useDispatch()
  const location = useLocation()

  const brand = useSelector((state) => state.reducer.brand)

  const numberOfLanguages = LANGUAGES_BY_BRAND[brand?.abbreviation]?.length
  const styleProps = {
    minHeight: numberOfLanguages > 1 ? 'calc(100vh - 32px)' : '100vh'
  }
  const classes = useStyles(styleProps)
  const isErrorPage = location.pathname.includes('public/error')

  dispatch(storeSelectedLanguageActionCreator(locale))

  const handleMobileVersion = () => {
    dispatch(storeMobileVersionActionCreator(window.innerWidth < BREAKPOINT_MD))
  }

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname + location.search
    })
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, locale])

  useEffect(() => {
    if (!!brand?.googleAnalyticsTrackingID) {
      ReactGA.initialize(brand?.googleAnalyticsTrackingID)
    }
    handleMobileVersion()
    window.addEventListener('resize', handleMobileVersion)

    return () => {
      window.removeEventListener('resize', handleMobileVersion)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    handleMobileVersion()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.innerWidth])

  return (
    <div className={classes.landing}>
      {!isErrorPage && <Header />}
      <CustomAlert />
      <Router />
      {!isErrorPage && <Footer />}
    </div>
  )
}

export default Landing
